import React, { forwardRef, useEffect } from 'react'

import { Grid, Row, Select, UnidadeGestoraFields } from 'components'
import { LoadingIcon } from 'components/Icons'
import { COLORS, SPACING } from 'utils'
import { PerfilUsuario } from 'utils/types'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'

export interface IDirectorsManagers {
  loadingProfiles?: boolean
  listProfiles?: PerfilUsuario[] | []
  statusUsarioFornecedor?: string
  perfilUsuarioId?: number
  setStatus?: (el: string) => void
  setPerfil?: (el: number) => void
  ref?: any
  setUnidadeGestoraID?: React.Dispatch<React.SetStateAction<IOnChangeUnidadeGestora>>
  unidadeGestoraId?: IOnChangeUnidadeGestora
  handleResetForm?: () => void
}
const DirectorsManagers: React.FC<IDirectorsManagers> = forwardRef(
  (
    {
      loadingProfiles,
      listProfiles,
      setPerfil,
      setStatus,
      statusUsarioFornecedor,
      perfilUsuarioId,
      unidadeGestoraId,
      setUnidadeGestoraID
    },
    ref
  ) => {
    const listOptonsStatus = [
      { label: 'Liberado', value: 'L' },
      { label: 'Bloqueado', value: 'B' },
      { label: 'Desativado', value: 'D' },
      { label: 'Pendente', value: 'P' },
      { label: 'Vencido', value: 'V' }
    ]

    return (
      <>
        <Grid
          gridCols="1fr 1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          alignItems="flex-start"
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <UnidadeGestoraFields
            ref={ref}
            gridCols={{
              Diretoria: 6,
              DiretoriaExecutiva: 6,
              Gerencia: 6,
              GerenciaGeral: 6,
              spacing: 2
            }}
            // defaultValue={unidadeGestoraId}
            onChange={setUnidadeGestoraID}
          />
          <Row>
            <Select
              value={statusUsarioFornecedor}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
              listOptions={listOptonsStatus}
              marginRight={SPACING.spacing30}
              width="150px"
              clearSelect={true}
            />
            {loadingProfiles ? (
              <LoadingIcon colorIcon={COLORS.blueFonts} marginLeft="1rem" />
            ) : (
              <Select
                value={perfilUsuarioId ? perfilUsuarioId : 'none'}
                onChange={(e) => setPerfil(parseInt(e.target.value))}
                label="Perfil"
                listOptions={listProfiles}
                width="150px"
                labelMenu="txDenominacao"
                valueMenu="idPerfilUsuario"
                clearSelect={true}
              />
            )}
          </Row>
        </Grid>
      </>
    )
  }
)

DirectorsManagers.displayName = 'cornitos'

export default DirectorsManagers
